/**
 * 拆分字符串为独立的 grapheme（字位）
 * 比如说 emoji 之类的，一个 emoji 的 length 可能对于1，但是是一个 grapheme
 * 参考：https://cestoliv.com/blog/how-to-count-emojis-with-javascript/
 * @param text
 */
export function splitTextByGrapheme(text: string): string[] {
    if (typeof Intl.Segmenter === 'function') {
        return Array.from(new Intl.Segmenter().segment(text)).map(i => i.segment);
    }
    // 这个不太准确，有的 emoji 是由多个 emoji 合并起来的，这个方法会把它们拆开
    return Array.from(text);
}
